import OfferActionList from './OfferActionList';

export default {
    list: 	OfferActionList
};
